import React, { useContext, useEffect, useState } from 'react';
import { OWNEPLOYEEMAP } from '../../../utils/Gr8piConfig';
import { growlErrors } from '../../../utils/NotificationUtil';
import { createSuperLink } from '../../../services/apps/SuperLinkService';
import { searchJobProfile } from '../../../services/apps/JobProfileService';
import NewSuperLinkFormContainer from './NewSuperLinkFormContainer';
import { searchAsmtTemp } from '../../../services/apps/AssessmentTempServices';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { CustomFunctionality, RespondentType } from '../../../shared/Constants';
import useCustomFunctionalityCheck from '../../../hooks/useCustomFunctionalityCheck';

const NewSuperLink = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();
  const history = useHistory();

  const [jobs, setJobs] = useState([]);
  const [isJpLoading, setIsJpLoading] = useState(false);
  const [asmtTemp, setAssmtTemp] = useState(null);
  const [temps, setTemps] = useState([]);
  const [isTempLoading, setIsTempLoading] = useState(false);

  const {
    doesAccountHaveAccessToCustomFunctionality,
    getReportsToAutomaticallyGenerate,
  } = useCustomFunctionalityCheck();
  const reportsToAutomaticallyGenerate = getReportsToAutomaticallyGenerate();

  const accountCanSelectMatchPercentageForCareerCounselingReports = doesAccountHaveAccessToCustomFunctionality(
    CustomFunctionality.MINIMUM_MATCH_PERCENTAGE_CC_REPORTS,
  );

  useEffect(() => {
    searchTemplate();
    // eslint-disable-next-line
  }, []);

  const handleSelectTemplate = (selectedTemp) => {
    if (selectedTemp) {
      const { id } = selectedTemp;
      setAssmtTemp(id);
      searchJob(null, id);
    }
  };

  const handleCancel = () => {
    history.push(`/accounts/${currentAccount}/super-links`);
  };

  const searchTemplate = async (query) => {
    try {
      setIsTempLoading(true);
      setTemps([]);

      const data = await searchAsmtTemp({
        aid: currentAccount,
        query,
      });

      setTemps(data);
    } catch (err) {
      growlErrors(growl, err);
    } finally {
      setIsTempLoading(false);
    }
  };

  const searchJob = async (query, tempId) => {
    try {
      setIsJpLoading(true);
      setJobs([]);

      const data = await searchJobProfile({
        aid: currentAccount,
        tempId,
        query,
      });

      setJobs(data);
    } catch (err) {
      growlErrors(growl, err);
    } finally {
      setIsJpLoading(false);
    }
  };

  const saveSuperLink = async (formValues) => {
    const {
      name,
      assessmentTemplate,
      respondentType,
      description,
      notes,
      notificationEmails,
      locale,
      reports,
      targetJob,
      sendRespondentReport,
      printFriendlyReport,
      sendRespondentCcPersonalityReport,
      sendRespondentCcInterestsReport,
      enabled,
      activationType,
      numberOfAssessmentsToDisableAfter,
      ccInterestsMinimumMatchPercentage,
      ccPersonalityMinimumMatchPercentage,
    } = formValues;

    const input = {
      accountId: currentAccount,
      name,
      description,
      notes,
      assessmentTemplateId: assessmentTemplate.id,
      respondentType,
      notificationEmails,
      reports,
      locale,
      targetJobId: targetJob.id,
      sendRespondentReport: !!sendRespondentReport,
      sendRespondentCcInterestsReport: !!sendRespondentCcInterestsReport,
      sendRespondentCcPersonalityReport: !!sendRespondentCcPersonalityReport,
      printFriendlyReport: !!printFriendlyReport,
      activationOptionsInput: {
        enabled,
        activationType,
        numberOfAssessmentsToDisableAfter: activationType === 'MANUAL' ? null : numberOfAssessmentsToDisableAfter,
      },
      ccInterestsMinimumMatchPercentage,
      ccPersonalityMinimumMatchPercentage,
    };

    try {
      const result = await createSuperLink(input);
      const { id, respondentType } = result.createSuperLink.superLink;

      let redirectUrl = `/accounts/${currentAccount}/super-links/${id}`;

      if (respondentType === RespondentType.INTERNAL) {
        redirectUrl = `${redirectUrl}?type=${RespondentType.INTERNAL}`;
      }

      history.push(redirectUrl);
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  const ownEmployeeMapForDropDown = OWNEPLOYEEMAP.map((ownEmploy) => ({
    text: formatMessage({ id: ownEmploy.name }),
    value: ownEmploy.id,
  }));

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <NewSuperLinkFormContainer
            handleSelectTemplate={handleSelectTemplate}
            assessmentTemplates={temps}
            searchTemp={(query) => searchTemplate(query)}
            isTempLoading={isTempLoading}
            ownEmployeeMap={ownEmployeeMapForDropDown}
            handleCancel={handleCancel}
            onSave={saveSuperLink}
            reportForDropDown={reportsToAutomaticallyGenerate}
            listJobProfiles={jobs}
            searching={isJpLoading}
            asmtTemp={asmtTemp}
            searchJob={searchJob}
            accountCanSelectMatchPercentageForCareerCounselingReports={
              accountCanSelectMatchPercentageForCareerCounselingReports
            }
          />
        </div>
      </div>
    </div>
  );
};

export default NewSuperLink;
